var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-fake-checkbox-union__wrapper"},_vm._l((_vm.data.list),function(item){return _c('checkbox',{key:item.id,attrs:{"data":item,"filter-key":_vm.data.key,"name":_vm.name,"action":_vm.data.action}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }